export const calendar = "Planning_calendar "
export const daynumber = "Planning_daynumber "
export const slot = "Planning_slot "
export const slot_new = "Planning_slot_new "
export const top_time = "Planning_top_time "
export const bottom_time = "Planning_bottom_time "
export const selected = "Planning_selected "
export const not_selected = "Planning_not_selected "
export const lesson_status = "Planning_lesson_status "
export const header = "Planning_header "
export const header_left = "Planning_header_left "
export const header_middle = "Planning_header_middle "
export const header_right = "Planning_header_right "
export const tabs = "Planning_tabs "
export const tab = "Planning_tab "
export const tab_active = "Planning_tab_active "
export const tab_small = "Planning_tab_small "
export const weeknumber = "Planning_weeknumber "
export const nothingfound = "Planning_nothingfound "
export const extraheader = "Planning_extraheader "
export const overlay = "Planning_overlay "
export const slot_absence = "Planning_slot_absence "
export const editblock = "Planning_editblock "
export const timeline = "Planning_timeline "
export const right_title = "Planning_right_title "
export const day_right = "Planning_day_right "
export const day_main = "Planning_day_main "
export const day_container = "Planning_day_container "
export const day_right_container = "Planning_day_right_container "
export const day_left = "Planning_day_left "
export const day_has_1_column = "Planning_day_has_1_column "
export const day_has_2_columns = "Planning_day_has_2_columns "
export const day_has_3_columns = "Planning_day_has_3_columns "
export const day_has_4_columns = "Planning_day_has_4_columns "
export const day_has_5_columns = "Planning_day_has_5_columns "
export const day_backdrop = "Planning_day_backdrop "
export const day_right_closed = "Planning_day_right_closed "
export const oneday = "Planning_oneday "
export const day_right_label = "Planning_day_right_label "
export const day_closeform = "Planning_day_closeform "
export const small_list_page = "Planning_small_list_page "
export const removetext = "Planning_removetext "
export const Calendar_title = "Calendar_title "
export const sidebar = "Planning_sidebar "
export const next_sidebar_pinned = "Planning_next_sidebar_pinned "
export const next_sidebar_fix_on_desktop = "Planning_next_sidebar_fix_on_desktop "
export const buttonbar = "Planning_buttonbar "
export const weekdates = "Planning_weekdates "
export const button = "Style_button "
export const hidden_date_input = "Planning_hidden_date_input "
export const buttonbar_section = "Planning_buttonbar_section "
export const newbuttons = "Planning_newbuttons "
export const newbuttons_trigger = "Planning_newbuttons_trigger "
export const newbuttons_popup = "Planning_newbuttons_popup "
export const day_header = "Planning_day_header "
export const teacher_title = "Planning_teacher_title "
export const checkbox_as_button = "Planning_checkbox_as_button "
export const close_popup_button = "Planning_close_popup_button "
export const indicators = "Planning_indicators "